import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

export const useApiClient = () => {
  const navigate = useNavigate();
  const apiClient = axios.create({
    baseURL: "https://api365.geoexpress.ge/api",
  });

  apiClient.interceptors.request.use((config) => {
    const token = Cookies.get("Token"); // Get token or session cookie
    if (token) {
      config.headers["token"] = `${token}`;
      return config;
    } else {
      navigate("/auth-signin"); // Navigate to login page
    }
    return config;
  });

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response ? error.response.status : null;
      //console.log(error);
      if (error.response.message === "User not Confirmed") {
        navigate("/user-confirmation"); // Navigate to user confirmation page
      }
      if (status === 401) {
        Cookies.remove("Token"); // Remove token or session cookie
        navigate("/auth-signin"); // Navigate to login page
      } else if (status === 404) {
        navigate("/not-found"); // Navigate to 404 page
      } else if (status === 500) {
        navigate("/not-found"); // Navigate to error page
      } else {
        //console.error("An error occurred:", error); // Handle other errors
      }
      return Promise.reject(error);
    }
  );

  return apiClient;
};
//const status = error.response ? error.response.status : null;
//console.log(error);
// if (error.response.message === "User not Confirmed") {
//   navigate("/user-confirmation"); // Navigate to user confirmation page
// }
// if (status === 401) {
//   Cookies.remove("Token"); // Remove token or session cookie
//   //navigate("/auth-signin"); // Navigate to login page
// } else if (status === 404) {
//   navigate("/not-found"); // Navigate to 404 page
// } else if (status === 500) {
//   navigate("/not-found"); // Navigate to error page
// } else {
//   console.error("An error occurred:", error); // Handle other errors
// }
